// steps/assinaturaCliente.validation.ts
import { AssinaturaFormData } from './PlanoAssinaturaForm';

export type ClienteErrors = Partial<{
    customerEmail: string;
    customerPhone: string;
}>;

export function validateClienteStep(form: AssinaturaFormData): ClienteErrors {
    const errors: ClienteErrors = {};

    // E-mail
    if (!form.customerEmail || !form.customerEmail.trim()) {
        errors.customerEmail = 'Informe o e-mail.';
    } else if (!isValidEmail(form.customerEmail)) {
        errors.customerEmail = 'E-mail inválido.';
    }

    // Telefone
    const phoneDigits = (form.customerPhone || '').replace(/\D/g, '');
    if (!phoneDigits) {
        errors.customerPhone = 'Informe o telefone.';
    } else if (phoneDigits.length < 10) {
        errors.customerPhone = 'Telefone incompleto.';
    }

    return errors;
}

/** ----------------- Helpers ----------------- */

function isValidEmail(email: string): boolean {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email.toLowerCase());
}
